"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiKey = getApiKey;

var _get = _interopRequireDefault(require("lodash/get"));

var _runtimeConfigHelper = require("./runtime-config-helper");

function getApiKey(name) {
  return (0, _get["default"])((0, _runtimeConfigHelper.getRuntimeConfig)()._apiKeys, "".concat(name));
}